import { Injectable } from '@angular/core';
import { Store, Action } from '@ngrx/store';

import * as CannedMessagesActions from './canned-messages.actions';
import * as fromCannedMessages from './canned-messages.reducer';
import * as CannedMessagesSelectors from './canned-messages.selectors';
import {
  CannedMessage,
  CannedMessageQuery
} from '@appgen-health-crm/api-interfaces';

@Injectable()
export class CannedMessagesFacade {
  cannedMessages$ = this.store.select(
    CannedMessagesSelectors.getAllCannedMessages
  );

  constructor(
    private store: Store<fromCannedMessages.CannedMessagesPartialState>
  ) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  loadCannedMessages(query?: CannedMessageQuery) {
    this.dispatch(CannedMessagesActions.getCannedMessages({ query }));
  }

  addCannedMessage(cannedMessage: CannedMessage) {
    this.dispatch(CannedMessagesActions.addCannedMessage({ cannedMessage }));
  }

  updateCannedMessage(cannedMessage: CannedMessage) {
    this.dispatch(CannedMessagesActions.updateCannedMessage({ cannedMessage }));
  }

  deleteCannedMessage(id: string) {
    this.dispatch(CannedMessagesActions.deleteCannedMessage({ id }));
  }
}
